// @ts-nocheck
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { authService } from "../../services/authService";
import Button from "../Button";
import "../signup/signupform.css";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, goggleAuthProvider } from "../../firebase.config";
import SvgComponent from "../SvgComponent";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { user, token } = await authService.loginUser(email, password);

      dispatch({
        type: "LOGIN",
        payload: { user, token },
      });

      navigate("/");
    } catch (error) {
      console.error("Login error:", error);
      setError(error.message || "Invalid login credentials");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError("");

    try {
      const { user, token } = await authService.loginWithGoogle(
        goggleAuthProvider
      );

      dispatch({
        type: "LOGIN",
        payload: { user, token },
      });

      navigate("/", { replace: true });
    } catch (error) {
      console.error("Google sign-in error:", error);
      setError(error.message || "Google authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginContainer">
      <div className="loginFormCard">
        <div className="loginHeader">
          <img src="/X.png" alt="Xeeds.AI Icon" className="loginLogo" />
          <h1>Welcome Back</h1>
          <p>Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="loginForm">
          <div className="inputGroup">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="loginInput"
              placeholder="Email address"
            />
          </div>

          <div className="inputGroup passwordGroup">
            <input
              type={showLoginPassword ? "text" : "password"}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="loginInput"
              placeholder="Password"
            />
            <button
              type="button"
              className="passwordToggle"
              onClick={() => setShowLoginPassword(!showLoginPassword)}
            >
              {!showLoginPassword ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <g
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5C5.636 5 2 12 2 12s3.636 7 10 7 10-7 10-7-3.636-7-10-7Z" />
                    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                  </g>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 14.834C21.308 13.332 22 12 22 12s-3.636-7-10-7a8.595 8.595 0 0 0-2 .236M12 9a2.995 2.995 0 0 1 3 3M3 3l18 18m-9-6a2.997 2.997 0 0 1-2.959-2.5M4.147 9c-.308.345-.585.682-.828 1C2.453 11.128 2 12 2 12s3.636 7 10 7c.341 0 .675-.02 1-.058"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>

          <button type="submit" className="loginButton" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div className="signupSeparator">OR</div>

        <button
          onClick={handleGoogleSignIn}
          className="googleButton"
          type="button"
          disabled={loading}
        >
          <svg
            className="googleIcon"
            viewBox="0 0 48 48"
            width="20"
            height="20"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
          </svg>
          Continue with Google
        </button>

        {error && <div className="errorMessage">{error}</div>}
        <div className="text-center mt-4">
          <a
            href="/auth/signup"
            className="text-sm text-primary-600 hover:text-primary-500"
          >
            Don't have an account?{" "}
            <span className=" text-blue-500">Sign up here</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
